import { createStore } from 'vuex'
import tab from './tab'
import createPersistedState from 'vuex-persistedstate'

// 创建 Vuex Store 实例
const store = createStore({
  state: {},
  getters: {},
  mutations: {},
  actions: {},
  modules: {
    tab
  },
  plugins: [
    createPersistedState({
      storage: window.localStorage, // 或者使用 sessionStorage
      paths: ['tab'] // 指定要持久化的模块
    })
  ]
})

export default store
